require('./bootstrap');


import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

createInertiaApp({
    title: (title) => (title ? title : 'Descargas'),
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: {route} })
            .mount(el);
    },

});

InertiaProgress.init({ color: '#f97316' });
